// src/utils/ScrollControl/scrollControl.ts

export const isProgrammaticScroll = {
  current: false,
};

let scrollTimeout: ReturnType<typeof setTimeout> | null = null;

/**
 * Safely perform programmatic scroll without triggering header scroll logic
 * Works with Next.js SSR safely
 */
export function programmaticScrollTo(
  options: ScrollToOptions,
  duration = 2000,
) {
  // ✅ SSR safety check
  if (typeof window === 'undefined') {
    return;
  }

  isProgrammaticScroll.current = true;

  window.scrollTo(options);

  if (scrollTimeout) {
    clearTimeout(scrollTimeout);
  }

  scrollTimeout = setTimeout(() => {
    isProgrammaticScroll.current = false;
  }, duration);
}
